export const categoryConstants = {
  FETCH_CATEGORIES_ACTION_REQUEST: 'FETCH_CATEGORIES_ACTION_REQUEST',
  FETCH_CATEGORIES_ACTION_SUCCESS: 'FETCH_CATEGORIES_ACTION_SUCCESS',
  FETCH_CATEGORIES_ACTION_FAILURE: 'FETCH_CATEGORIES_ACTION_FAILURE',

  CREATE_CATEGORY_ACTION_REQUEST: 'CREATE_CATEGORY_ACTION_REQUEST',
  CREATE_CATEGORY_ACTION_SUCCESS: 'CREATE_CATEGORY_ACTION_SUCCESS',
  CREATE_CATEGORY_ACTION_FAILURE: 'CREATE_CATEGORY_ACTION_FAILURE',
};
